export type AccessioningPresignedUrlGetter = (
  fileName: string,
  contentType: string
) => Promise<{ url: string; key: string }>;

export const ACCESSIONING_UPLOAD_ERROR =
  "The document could not be uploaded. Check your connection and try again.";

export async function uploadAccessioningDocument(
  file: File,
  getPresignedUrl: AccessioningPresignedUrlGetter
): Promise<string> {
  const { url, key } = await getPresignedUrl(file.name, file.type);
  const response = await fetch(url, {
    method: "PUT",
    body: file,
    headers: { "Content-Type": file.type },
  });

  if (!response.ok) throw new Error(ACCESSIONING_UPLOAD_ERROR);
  return key;
}
